export default __webpack_public_path__ + "static/media/logo.6337fba1.png";